import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    termsContainer: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      fontFamily: 'Arial, sans-serif',
      lineHeight: '1.6',
    },
    sectionTitle: {
      fontSize: '24px',
      marginBottom: '10px',
      borderBottom: '1px solid #333',
      paddingBottom: '5px',
    },
    sectionContent: {
      fontSize: '16px',
      marginBottom: '20px',
    },
  }));
  
const TermsOfService = () => {
    const classes = useStyles();
    return (
        
        <div className={classes.termsContainer}>
        <h2>Terms of Service</h2>
        <p>
          These Terms of Service govern your use of Trending Data Hub and its services. By accessing or using the website, you agree to comply with these terms.
        </p>
  
        <div>
        <h3 className={classes.sectionTitle}>1. Content Usage</h3>
        <p className={classes.sectionContent}>
          Users may read, share, and comment on the content published on Trending Data Hub. However, unauthorized copying, reproduction, or distribution of the content without proper attribution or permission is prohibited.
        </p>
      </div>
      <div>
        <h3 className={classes.sectionTitle}>2. User Conduct</h3>
        <p className={classes.sectionContent}>
          Users must not engage in any unlawful, abusive, or malicious activities on Trending Data Hub. Respect other users' opinions, avoid spamming or trolling behavior, and adhere to community guidelines when commenting or interacting with the content.
        </p>
        </div>
        <div>
        <h3 className={classes.sectionTitle}>3. Intellectual Property</h3>
        <p className={classes.sectionContent}>
          All content, including articles, images, and videos, published on Trending Data Hub is the intellectual property of the website. Users must not infringe upon copyrights or trademarks.
        </p>
        </div>
        <div>
        <h3 className={classes.sectionTitle}>4. Accuracy of Information</h3>
        <p className={classes.sectionContent}>
          While Trending Data Hub strives to provide accurate and up-to-date information, the website does not guarantee the accuracy, completeness, or reliability of the content. Users are encouraged to verify information before making decisions based on it.
        </p>
        </div>
        <div>
        <h3 className={classes.sectionTitle}>5. User Responsibilities</h3>
        <p className={classes.sectionContent}>
          Users are responsible for their interactions and activities on Trending Data Hub. This includes ensuring the accuracy of comments, respecting others' opinions, and complying with the website's guidelines and applicable laws.
        </p>
        </div>
        <div>
        <h3 className={classes.sectionTitle}>6. Changes to Terms</h3>
        <p className={classes.sectionContent}>
          Trending Data Hub reserves the right to update or modify these Terms of Service at any time without prior notice. Continued use of the website constitutes acceptance of the revised terms.
        </p>
        </div>
        {/* Include more sections as needed based on your website's specific services and terms */}
      </div>
    );
  };
  
export default TermsOfService;
